<!-- <p>claims-container works!</p> -->
<br />
<section *ngIf="screenSize == ScreenType.Mobile || true">
  <mat-grid-list
    *ngIf="isClaims"
    [cols]="screenSize == ScreenType.Mobile ? '1' : '3'"
    rowHeight="100px"
    [gutterSize]="'5px'"
  >
    <mat-grid-tile
      ><mat-card class="incident-counter-card"
        ><mat-card-header class="incident-counter-card-header">{{
          "today CLAIMS" | uppercase
        }}</mat-card-header>
        <mat-card-content class="incident-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text"
          >
            {{ todayClaim }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >

    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header-custom">{{
          "today Open Claims" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text-custom"
          >
            {{ todayOpenClaim }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >
    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header-custom">{{
          "today CLOSED CLAIMS" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text-custom"
          >
            {{ todayClosedClaim }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >
  </mat-grid-list>
  <mat-divider></mat-divider>
  <mat-grid-list
    *ngIf="isClaims"
    [cols]="screenSize == ScreenType.Mobile ? '1' : '3'"
    rowHeight="100px"
    [gutterSize]="'5px'"
  >
    <mat-grid-tile
      ><mat-card class="incident-counter-card"
        ><mat-card-header class="incident-counter-card-header">{{
          "TOTAL CLAIMS" | uppercase
        }}</mat-card-header>
        <mat-card-content class="incident-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text"
          >
            {{ totalClaim }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >

    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header-custom">{{
          "Total Open Claims" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text-custom"
          >
            {{ totalOpenClaim }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >
    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header-custom">{{
          "Total CLOSED CLAIMS" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text-custom"
          >
            {{ totalClosedClaim }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >
  </mat-grid-list>
  <mat-divider></mat-divider>
  <mat-grid-list
    *ngIf="isClaims"
    [cols]="screenSize == ScreenType.Mobile ? '1' : '3'"
    rowHeight="100px"
    [gutterSize]="'5px'"
  >
    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header">{{
          "Total Claim amount" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text"
          >
            {{ totalClaimAmount }}
          </div>

          <!-- <mat-icon class="counter-icon">visibility</mat-icon> -->
        </mat-card-content>
      </mat-card></mat-grid-tile
    >

    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header-custom">{{
          "Total Open Claim amount" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text-custom"
          >
            {{ totalOpenClaimAmount }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >
    <mat-grid-tile
      ><mat-card class="visitor-counter-card"
        ><mat-card-header class="visitor-counter-card-header-custom">{{
          "Total Closed Claim amount" | uppercase
        }}</mat-card-header>
        <mat-card-content class="visitor-counter-card-content">
          <div
            *ngIf="!dashboardData.status.isFetchingAPIRequest"
            class="counter-text-custom"
          >
            {{ totalClosedClaimAmount }}
          </div>
        </mat-card-content>
      </mat-card></mat-grid-tile
    >
  </mat-grid-list>
  <mat-divider></mat-divider>
  <div class="search-filter-wrapper">
    <mat-grid-list
      [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
      rowHeight="100px"
      [gutterSize]="'15px'"
    >
      <mat-grid-tile>
        <div class="mat-inside-grid-tile">
          <mat-form-field subscriptSizing="dynamic" appearance="outline">
            <mat-label>Enter Start and End Date</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
              <input
                matStartDate
                formControlName="start"
                placeholder="Start date"
              />
              <input
                matEndDate
                formControlName="end"
                [min]="currentDate"
                placeholder="End date"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            @if (range.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>Invalid start date</mat-error>
            } @if (range.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>Invalid end date</mat-error>
            }
          </mat-form-field>
          <button
            *ngIf="isClickedSubmit"
            mat-icon-button
            (click)="onGetResetData()"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="screenSize != ScreenType.Mobile"></mat-grid-tile>
      <mat-grid-tile>
        <div class="button-inside-grid-tile">
          <button
            [disabled]="
              !(
                range.controls.end.value != null &&
                range.controls.start.value != null
              )
            "
            (click)="onClickGetRangeData()"
            mat-raised-button
          >
            Submit
          </button>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <mat-divider></mat-divider>
  <div>
    <mat-grid-list cols="1" [gutterSize]="'15px'" rowHeight="600px">
      <mat-grid-tile
        ><mat-card class="incident-charts-card"
          ><mat-card-header class="incident-counter-card-header"
            >CLAIM STATUS</mat-card-header
          >
          <mat-card-content class="incident-charts-card-content">
            <app-incident-status-graph
              [graphIncidentData]="claimStatusData"
            ></app-incident-status-graph>
          </mat-card-content> </mat-card
      ></mat-grid-tile>
    </mat-grid-list>
  </div>
  <mat-divider></mat-divider>
</section>
<div class="service-requests-container">
  <mat-grid-list rowHeight="110px" cols="1">
    <mat-grid-tile
      [rowspan]="
        complaintList.length > 5 ? 5 : complaintList.length >= 3 ? 4 : 3
      "
      ><div class="div-inside-grid-tile">
        <div class="requests-header">Claims ({{ tempComplaints.length }})</div>
        <div class="NoData-Available" *ngIf="tempComplaints.length == 0">
          No Data Available
        </div>
        <div
          [ngClass]="{
            'requests-list':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,
            'requests-list-mobile': screenSize == ScreenType.Mobile
          }"
        >
          <div
            class="search-container"
            [ngStyle]="
              enteredValue.length > 0 && complaintList.length == 0
                ? { height: '100px' }
                : {}
            "
          >
            <div class="search-box-container">
              <!-- Enhanced Filter Section -->
              <div class="filters-row">
                <!-- Primary Filter -->
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Filter By</mat-label>
                  <mat-select
                    [value]="selectedPrimaryFilter"
                    (selectionChange)="onPrimaryFilterChange($event)"
                  >
                    <mat-option value="all">All</mat-option>
                    <mat-option value="my-issues">My Issues</mat-option>
                    <mat-option value="assigned-to">Assigned To</mat-option>
                    <mat-option value="reported-by">Reported By</mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- My Issues Sub-filter -->
                <mat-form-field
                  *ngIf="selectedPrimaryFilter === 'my-issues'"
                  subscriptSizing="dynamic"
                  appearance="outline"
                >
                  <mat-label>My Issues Type</mat-label>
                  <mat-select
                    [value]="selectedMyIssuesType"
                    (selectionChange)="onMyIssuesTypeChange($event)"
                  >
                    <mat-option value="all">All</mat-option>
                    <mat-option value="reported">Reported by Me</mat-option>
                    <mat-option value="assigned">Assigned to Me</mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Assigned To Multi-select -->
                <mat-form-field
                  *ngIf="selectedPrimaryFilter === 'assigned-to'"
                  subscriptSizing="dynamic"
                  appearance="outline"
                >
                  <mat-label>Assigned Users</mat-label>
                  <mat-select
                    multiple
                    [value]="selectedAssignedUsers"
                    (selectionChange)="onAssignedUsersChange($event)"
                  >
                    <mat-option
                      *ngFor="let user of availableAssignedUsers"
                      [value]="user.userId"
                    >
                      {{ user.userName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Reported By Multi-select -->
                <mat-form-field
                  *ngIf="selectedPrimaryFilter === 'reported-by'"
                  subscriptSizing="dynamic"
                  appearance="outline"
                >
                  <mat-label>Reporters</mat-label>
                  <mat-select
                    multiple
                    [value]="selectedReporters"
                    (selectionChange)="onReportersChange($event)"
                  >
                    <mat-option
                      *ngFor="let reporter of availableReporters"
                      [value]="reporter"
                    >
                      {{ reporter }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Status Filter -->
                <mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Claim Status</mat-label>
                  <mat-select
                    [value]="selectedStatus"
                    (selectionChange)="onChangeDataTable($event)"
                  >
                    <mat-option value="-1">All</mat-option>
                    <mat-option value="0">Open</mat-option>
                    <mat-option value="1">Close</mat-option>
                    <mat-option value="2">Verified</mat-option>
                    <mat-option value="3">Snooze</mat-option>
                    <mat-option value="4">In-progress</mat-option>
                    <mat-option value="8">Completed</mat-option>
                    <mat-option value="5">On-hold</mat-option>
                    <mat-option value="6">Approved</mat-option>
                    <mat-option value="7">Rejected</mat-option>
                  </mat-select>
                </mat-form-field>

                <!-- Search Input -->
                <mat-form-field
                  *ngIf="tempComplaints.length > 0"
                  appearance="outline"
                  [subscriptSizing]="'dynamic'"
                >
                  <mat-label>Search</mat-label>
                  <input (keyup)="applyFilterCustom($event)" matInput #input />
                </mat-form-field>

                <!-- Clear Filters Button -->
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="clearAllFilters()"
                  class="clear-filters-btn"
                >
                  <mat-icon>clear</mat-icon>
                  Clear Filters
                </button>
              </div>
            </div>
            <div
              class="no-data-div"
              *ngIf="enteredValue.length > 0 && complaintList.length == 0"
            >
              No request found!
            </div>
          </div>
          <div class="complaints-table" *ngIf="screenSize != ScreenType.Mobile">
            <table mat-table [dataSource]="complaintList">
              <ng-container matColumnDef="no">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ i + 1 }}
                </td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th
                  style="border-right: 1px solid"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Request Id
                </th>
                <td
                  style="border-right: 1px solid"
                  mat-cell
                  *matCellDef="let row"
                >
                  {{ row.complainId.split("-")[0] }}
                </td>
              </ng-container>
              <ng-container matColumnDef="assignee">
                <th
                  style="border-right: 1px solid"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Assignee
                </th>
                <td
                  style="border-right: 1px solid"
                  mat-cell
                  *matCellDef="let row"
                >
                  {{ row.complainIncidentDetails.assignedTo }}
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th
                  style="border-right: 1px solid"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Date
                </th>
                <td
                  style="border-right: 1px solid"
                  mat-cell
                  *matCellDef="let row"
                >
                  <!-- {{ getFormatedDate(row.complainAddDate) | date : "short" }} -->
                  {{ row.complainAddDate | date : "full" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Details">
                <th
                  style="text-align: center"
                  mat-header-cell
                  *matHeaderCellDef
                  aria-label="row actions"
                >
                  Details
                </th>
                <td
                  style="text-align: center"
                  mat-cell
                  *matCellDef="let element"
                >
                  <button
                    [disabled]="
                      isShowDetails && expandedDetail == element.complainId
                    "
                    (click)="onShowDetails(element)"
                    mat-raised-button
                  >
                    <mat-icon *ngIf="expandedDetail != element.complainId"
                      >add</mat-icon
                    >
                    <mat-icon
                      *ngIf="
                        isShowDetails && expandedDetail == element.complainId
                      "
                      >remove</mat-icon
                    >
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="time">
                <th
                  style="border-right: 1px solid"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Subject
                </th>
                <td
                  style="border-right: 1px solid"
                  mat-cell
                  *matCellDef="let row"
                >
                  {{ row.complainSubject }}
                </td>
              </ng-container>
              <ng-container matColumnDef="asset">
                <th
                  style="border-right: 1px solid"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Description
                </th>
                <td
                  style="border-right: 1px solid"
                  mat-cell
                  *matCellDef="let row"
                >
                  {{ row.complainDescription }}
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th
                  style="border-right: 1px solid; text-align: center"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Status
                </th>
                <td
                  style="border-right: 1px solid; text-align: center"
                  mat-cell
                  *matCellDef="let row"
                >
                  <!-- [ngStyle]="
                        row.security == 'Verified'
                          ? { 'background-color': 'green' }
                          : { 'background-color': 'red' }
                      " -->
                  <button
                    [disabled]="row.incidentStatus == 3"
                    (click)="onClickStatus(row)"
                    mat-raised-button
                    [ngStyle]="
                      row.complainIncidentDetails.incidentStatus == 3
                        ? { 'background-color': '#ffbf00' }
                        : row.complainIncidentDetails.incidentStatus == 0 ||
                          row.incidentStatus == 8
                        ? { 'background-color': 'green' }
                        : row.complainIncidentDetails.incidentStatus == 1
                        ? { 'background-color': 'red' }
                        : { 'background-color': 'gray' }
                    "
                  >
                    <!-- {{ row.incidentStatus == "3" ? "Snoozed" : ("Snooze" | titlecase) }} -->
                    {{
                      row.complainIncidentDetails.incidentStatus == 1
                        ? "Closed"
                        : row.complainIncidentDetails.incidentStatus == 0
                        ? "Open"
                        : row.complainIncidentDetails.incidentStatus == 2
                        ? "Verified"
                        : row.complainIncidentDetails.incidentStatus == 3
                        ? "Snoozed"
                        : row.complainIncidentDetails.incidentStatus == 4
                        ? "In-Progress"
                        : row.complainIncidentDetails.incidentStatus == 5
                        ? "On-Hold"
                        : row.complainIncidentDetails.incidentStatus == 6
                        ? "Approved"
                        : row.complainIncidentDetails.incidentStatus == 7
                        ? "Rejected"
                        : row.complainIncidentDetails.incidentStatus == 8
                        ? "Completed"
                        : ("Not Specified" | titlecase)
                    }}
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="details">
                <th
                  style="border-right: 1px solid; text-align: center"
                  mat-header-cell
                  *matHeaderCellDef
                  aria-label="row actions"
                ></th>
                <td
                  style="border-right: 1px solid; text-align: center"
                  mat-cell
                  *matCellDef="let element"
                >
                  <!-- <button (click)="onShowDetails(element)" mat-raised-button>
                      <mat-icon>add</mat-icon>
                    </button> -->
                  <!-- <button
                      [disabled]="element.incidentStatus == '3'"
                      (click)="onSnoozeIncident(element)"
                      mat-raised-button
                    >
                      {{ element.incidentStatus == "3" ? "Snoozed" : "Snooze" }}
                    </button> -->
                </td>
              </ng-container>
              <tr
                class="table-header"
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <app-lodged-complaints-card
            *ngIf="screenSize == ScreenType.Mobile"
            [complaintsData]="complaintList"
            [complaintsType]="'Claim'"
            (showDetails)="onShowDetails($event)"
            (snoozeIncident)="onSnoozeIncident($event)"
          ></app-lodged-complaints-card>
        </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
<ng-template #RefreshingRequest>
  <h2 matDialogTitle>Refreshing Request Data</h2>
  <mat-dialog-content><i>Please wait!</i> </mat-dialog-content>
  <mat-dialog-actions>
    <mat-spinner></mat-spinner>
  </mat-dialog-actions>
</ng-template>
